import { createSelector, MemoizedSelector } from '@ngrx/store';
import { OrderHistoryList, StateUtils } from '@spartacus/core';
import { OrderState, StateWithOrder } from '../order-state';
import { getOrderState } from './feature.selector';

export const getOrdersListState: MemoizedSelector<
  StateWithOrder,
  StateUtils.LoaderState<OrderHistoryList>
> = createSelector(getOrderState, (state: OrderState) => state.ordersList);

export const getOrdersListLoaded: MemoizedSelector<StateWithOrder, boolean> = createSelector(
  getOrdersListState,
  (state: StateUtils.LoaderState<OrderHistoryList>) => StateUtils.loaderSuccessSelector(state),
);

export const getOrdersListLoading: MemoizedSelector<StateWithOrder, boolean> = createSelector(
  getOrdersListState,
  (state: StateUtils.LoaderState<OrderHistoryList>) => StateUtils.loaderLoadingSelector(state),
);

export const getOrdersList: MemoizedSelector<StateWithOrder, OrderHistoryList> = createSelector(
  getOrdersListState,
  (state: StateUtils.LoaderState<OrderHistoryList>) => StateUtils.loaderValueSelector(state),
);
